import {Box, Button, ClickAwayListener, IconButton, Paper, Tooltip, Typography} from '@mui/material'
import {styled} from '@mui/material/styles'
import {FILTERS_DRAWER_WIDTH} from '../components/FilterPanel/FilterPanelStyle'
import PropTypes from 'prop-types'

export const MainBox = styled(Box, {shouldForwardProp: (prop) => prop !== 'isTimeout'})(({isTimeout}) => ({
  display: 'flex',
  flexFlow: 'column',
  maxWidth: 'calc(100vw - 64px)',
  marginLeft: `-${FILTERS_DRAWER_WIDTH}px`,
  backgroundColor: 'background.default',
  padding: '16px',
  marginTop: isTimeout ? '50px' : '45px',
  marginBottom: isTimeout ? '5px' : ''
}))

export const ChartContainer = styled(Paper)(() => ({
  padding: `16px`,
  borderRadius: `8px`,
  marginBottom: `16px`,
  marginRight: `16px`
}))

export const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.h6.fontSize,
  fontWeight: theme.typography.fontWeightSemibold,
  color: theme.palette.hpAccentBlack,
  marginBottom: '10px'
}))

export const ToBeStyledTooltip = ({className, onClickAway, ...props}) => (
  <ClickAwayListener onClickAway={onClickAway}>
    <Tooltip
      {...props}
      PopperProps={{
        disablePortal: true,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [20, -20]
            }
          }
        ]
      }}
      sx={{
        ':hover': {backgroundColor: 'transparent'},
        ':focus': {border: 'none'}
      }}
      classes={{tooltip: className}}
      placement='bottom-start'
    />
  </ClickAwayListener>
)

ToBeStyledTooltip.propTypes = {
  className: PropTypes.string,
  onClickAway: PropTypes.func
}

export const StyledTooltip = styled(ToBeStyledTooltip)(({theme}) => ({
  borderRadius: '8px',
  width: `300px`,
  fontSize: theme.typography.subtitle2.fontSize,
  backgroundColor: theme.palette.hpBlack,
  fontFamily: theme.typography.fontFamily,
  lineHeight: '16px'
}))

export const StyledIconButton = styled(IconButton)(({theme}) => ({
  color: theme.palette.hpPrimary,
  marginTop: '-10px'
}))
export const StyledZoomButton = styled(Button)(({theme}) => ({
  backgroundColor: 'transparent',
  color: theme.palette.hpPrimary,
  borderColor: theme.palette.hpBaseLight,
  '&:hover': {
    backgroundColor: theme.palette.hpWhite,
    borderColor: theme.palette.hpBaseLight
  },
  '&:focus': {borderColor: theme.palette.hpBaseLight}
}))
export const StyledZoomResetButton = styled(Button)(({theme}) => ({
  textTransform: 'none',
  '&:disabled': {
    color: theme.palette.hpWhite,
    backgroundColor: theme.palette.hpGrayDark
  },
  '&:hover': {
    backgroundColor: theme.palette.hpPrimaryDarkest
  },

  '& .MuiTouchRipple-child ': {
    backgroundColor: theme.palette.hpPrimaryDarkest
  }
}))
export const StyledMarkerButton = styled(Button)(({theme, ismenuopen}) => ({
  textTransform: 'none',

  backgroundColor: ismenuopen ? theme.palette.hpPrimary : theme.palette.hpWhite,
  border: `2px solid ${theme.palette.hpPrimary}`,
  color: ismenuopen ? theme.palette.hpWhite : theme.palette.hpPrimary,

  '&:focus': {border: `2px solid ${theme.palette.hpPrimary}`},
  '& .MuiTouchRipple-child ': {
    backgroundColor: theme.palette.hpPrimaryDarkest
  },
  '&:disabled': {
    color: theme.palette.hpWhite,
    backgroundColor: theme.palette.hpGrayDark,
    border: 0
  },
  '&:hover': {
    backgroundColor: theme.palette.hpPrimary,
    color: theme.palette.hpWhite
  }
}))

export const StyledBox = styled(Box, {shouldForwardProp: (prop) => prop !== 'isTableContainer'})(
  ({theme, isTableContainer}) => ({
    width: isTableContainer ? '100' : '95%',
    height: '300px',
    [theme.breakpoints.up('xl')]: {
      height: '400px'
    },
    [theme.breakpoints.between('xs', 'sm')]: {
      height: '500px'
    }
  })
)
